// SiteUp: limite funcional de sugestão de resposta (caracteres de UI/canal),
// não confundir com teto de tokens do modelo.
export const AI_SUGGESTION_MAX_CHARS = 1200;

// Preview colapsado: ~3-4 linhas em desktop; acima disso o card expande/recolhe.
export const AI_SUGGESTION_PREVIEW_CHARS = 320;

/**
 * Garante string segura e corta no limite funcional de 1200 chars.
 * @param {unknown} text
 * @param {number} [max=AI_SUGGESTION_MAX_CHARS]
 * @returns {string}
 */
export function clampSuggestionText(text, max = AI_SUGGESTION_MAX_CHARS) {
  const value = text == null ? '' : String(text);
  if (value.length <= max) return value;
  return value.slice(0, max);
}

/**
 * Texto exibido no preview colapsado (sem truncar o valor "real" da sugestão).
 * @param {string} text
 * @param {boolean} expanded
 * @param {number} [previewChars=AI_SUGGESTION_PREVIEW_CHARS]
 */
export function suggestionDisplayText(
  text,
  expanded,
  previewChars = AI_SUGGESTION_PREVIEW_CHARS
) {
  const value = text == null ? '' : String(text);
  if (expanded || value.length <= previewChars) return value;
  return value.slice(0, previewChars);
}

/**
 * @param {string} text
 * @param {number} [previewChars=AI_SUGGESTION_PREVIEW_CHARS]
 */
export function suggestionNeedsExpand(
  text,
  previewChars = AI_SUGGESTION_PREVIEW_CHARS
) {
  return String(text || '').length > previewChars;
}
